import type { QTableColumn } from 'quasar';
import { formatDate } from 'src/utils/formatDate';
export interface EnqueteTemplateGetAttributes {
  id: string;
  name: string;
  question_template_ids: string[];
  created_at: string;
  updated_at: string;
}
export interface EnqueteTemplateSendAttributes {
  name: string;
  question_template_ids: string[];
}
export class EnqueteTemplateModel {
  id: string;
  name: string;
  question_template_ids: string[];
  created_at: string;
  updated_at: string;

  constructor(input?: EnqueteTemplateGetAttributes) {
    this.id = input ? input.id : '';
    this.name = input ? input.name : '';
    this.question_template_ids = input ? input.question_template_ids : [];
    this.created_at = input ? formatDate(input.created_at) : '';
    this.updated_at = input ? formatDate(input.updated_at) : '';
  }

  getId(): string {
    return this.id;
  }
  getCreateAttributes(): EnqueteTemplateSendAttributes {
    return {
      name: this.name,
      question_template_ids: this.question_template_ids,
    };
  }
  getUpdateAttributes(): EnqueteTemplateSendAttributes {
    return {
      name: this.name,
      question_template_ids: this.question_template_ids,
    };
  }
}
export type EnqueteTemplateCollection = EnqueteTemplateModel[];

export const EnqueteTemplateTableColumns: QTableColumn[] = [
  {
    name: 'id',
    label: 'ID',
    align: 'left',
    field: 'id',
    sortable: true,
  },
  {
    name: 'name',
    label: 'アンケートテンプレート名',
    align: 'left',
    field: 'name',
    sortable: true,
  },
  {
    name: 'created_at',
    label: '作成日',
    align: 'left',
    field: 'created_at',
    sortable: true,
  },
  {
    name: 'updated_at',
    label: '更新日',
    align: 'left',
    field: 'updated_at',
    sortable: true,
  },
];
